import 'babel-polyfill';
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import axios from "axios";
import './element-variables.scss'
import VueRx from 'vue-rx';

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(VueRx);

// 请求拦截器
axios.interceptors.request.use(
  config => {
    const token = window.localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = token;
    }
    config.headers["X-Client-Type"] = "web";
    config.headers["X-Client-Version"] = "";
    return config;
  },
  error => {
    return Promise.error(error);
  }
);

router.beforeEach((to, form, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title || "大国工匠系统，让商业智能系统赋值企业运营";
  }
  next();
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
